exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filepond--action-process-item{visibility:hidden}", ""]);

// exports
